<template>
  <div>
    <my-table
      :data="data"
      :loading="loading"
      :headers="headers"
      :query="query"
      @delete="handleDelete"
      @search="handleSearch"
      @refresh="handleRefresh"
      @create="handleCreate"
      @edit="handleEdit"
      @change-page="handleChangePage"
      @change-limit="handleChangeLimit"
    />
    <detail
      v-model:visible="visible"
      :id="itemId"
      @save-success="handleSaveSuccess"
    />
  </div>
</template>
<script>
import * as _ from 'lodash'
import Detail from './PaymentAmountDetail.vue'
import listMethods from '../../utils/listMethods'
import listData from '../../utils/listData'
export default {
  components: {
    Detail
  },
  data () {
    return {
      ...listData,
      listApiUrl: '/lookups/payment_amounts',
      headers: [{
        name: 'amount',
        caption: 'Эмчилгээний төлбөр',
        type: 'currency',
        width: '100px'
      }, {
        name: 'note',
        caption: 'Тайлбар',
        width: 'auto'
      }, {
        name: 'createdAt',
        caption: 'Бүртгэсэн огноо',
        type: 'Date',
        width: '100px'
      }, {
        name: 'createdBy.firstName',
        caption: 'Бүртгэсэн хэрэглэгч',
        width: '110px'
      }],
      visible: false,
      itemId: null,
      query: { page: 1, limit: 15, sort: [{ name: 'createdAt', type: 'DESC' }], search: [] }
    }
  },
  beforeMount () {
    this.getList()
  },
  beforeUnmount () {
    this.handleCancelToken()
  },
  methods: {
    ...listMethods,
    async handleDelete (id) {
      try {
        await this.showConfirm({ message: 'Та тухайн бүртгэлийг устгахдаа итгэлтэй байна уу?' })
        await this.axios.delete(`/lookups/payment_amount/${id}`)
        _.remove(this.data[0], { id })
        this.data[1]--
        this.showToast('Амжилттай устгалаа.')
      } catch (err) {
        this.handleError(err)
      }
    },
    handleCreate () {
      this.itemId = null
      this.visible = true
    },
    handleEdit (id) {
      this.itemId = id
      this.visible = true
    },
    handleSaveSuccess (data) {
      const index = this.data[0].findIndex(c => c.id === data.id)
      if (index === -1) {
        this.data[0].unshift(data)
      } else {
        this.data[0].splice(index, 1, data)
      }
      this.visible = false
    }
  }
}
</script>
